import type { CellData, RowData } from '@tanstack/react-table'

import { HighlightText } from '@/components/ui/table/DataTable/HighlightText'
import type { CellContext } from '@/components/ui/table/types'
import { numberToCurrency } from '@/utils'

export const AmountCell = <TData extends RowData, TValue extends CellData>(
  cell: CellContext<TData, TValue>,
): React.ReactNode => {
  const amount = cell.getValue() as number
  const isNegative = amount < 0
  const searchQuery = cell.table.options.meta?.searchQuery
  const formatted = numberToCurrency(amount)

  return (
    <span
      className={`block truncate font-normal ${isNegative ? 'text-red-600' : 'text-emerald-500'}`}
    >
      <HighlightText text={formatted} query={searchQuery} />
    </span>
  )
}
